module.exports = __webpack_public_path__ + "assets/img/incorrect-icon.eb59ada1.svg";